import {
  activityScoreFilter,
  bioFilter,
  eventsFilter,
  geoLocationFilter,
  hasPastDueSubscriptionFilter,
  headlineFilter,
  invitationLinkIdsFilter,
  isAvatarSetFilter,
  joinedCommunityDaysAgoFilter,
  lastLoggedInDaysAgoFilter,
  levelFilter,
  locationFilter,
  nameFilter,
  onlineStatusFilter,
  paywallsFilter,
  roleFilter,
  spaceGroupsFilter,
  spacesFilter,
  tagsFilter,
} from "../SettingsApp/ManageMembers/TabContent/Filters/filterConfiguration";

export const memberDirectoryFilters = [
  nameFilter,
  bioFilter,
  headlineFilter,
  locationFilter,
  geoLocationFilter,
  roleFilter,
  invitationLinkIdsFilter,
  spacesFilter,
  spaceGroupsFilter,
  onlineStatusFilter,
  tagsFilter,
  paywallsFilter,
  eventsFilter,
  hasPastDueSubscriptionFilter,
  joinedCommunityDaysAgoFilter,
  lastLoggedInDaysAgoFilter,
  isAvatarSetFilter,
  activityScoreFilter,
  levelFilter,
];
